package com.downdogapp.client.singleton

import com.downdogapp.client.MANIFEST
import com.downdogapp.client.api.RecordEventRequest
import com.downdogapp.client.manifestInitialized

object Logger {

  // Used because swift doesn't support default values for parameters
  fun logEvent(name: String) = logEvent(name, mapOf())

  fun logEvent(name: String, properties: Map<String, String?> = mapOf()) {
    println("Event: $name $properties")

    // Firebase does not allow . in its events
    Firebase.logEvent(name.replace(".", "_").take(40), properties)

    if (manifestInitialized() && MANIFEST.enabledEventLoggingSubstrings.any { name.contains(it) }) {
      Network.post(
        RecordEventRequest(
          name = name,
          properties = properties
        )
      )
    }
  }

  fun logError(name: String, properties: Map<String, String?> = mapOf()) {
    logEvent("error.$name", properties)
  }

  fun logClick(name: String, properties: Map<String, String?> = mapOf()) {
    logEvent("click.$name", properties)
  }

  fun logScreenStart(name: String) {
    logEvent("screen_start.$name")
  }

  fun onCredChanged() { // android and ios
    Firebase.onCredChanged()
  }
}
